/*@ngInject*/
const DebuggerDirective = function ($timeout, $document) {

    let linkFunction = function ($scope, $element, $attr) {

        function toggleDebugger() {
             $scope.debuggingMode = !$scope.debuggingMode;
            toggleFormViewerDebuggerClass($scope.debuggingMode);
        }

        function toggleFormViewerDebuggerClass(isDebugging) {
            const debuggerClass = 'debuggerEnabled';
            if(isDebugging) {
                $element.addClass(debuggerClass);
            }
            else {
                $element.removeClass(debuggerClass);
            }
        }


        let handleKeyUp = (event) => {
            let isPressingD = event.keyCode === 68,
                isPressingShift = event.shiftKey,
                isPressingAlt = event.altKey,
                isCorrectKeyboardCombo = isPressingD && isPressingShift && isPressingAlt;

            if(isCorrectKeyboardCombo) {
                toggleDebugger();
            }

            $timeout();
        };


        $document.on('keyup.UIFormViewerDirective', handleKeyUp);

        $scope.$on('$destroy', function () {
            $document.off('keyup.UIFormViewerDirective', handleKeyUp);
        });
    };

    return {
        link: linkFunction,
        restrict: 'A'
    };
};

angular.module('umFormViewer')
    .directive('uiDebuggerDirective', DebuggerDirective);
